export default __webpack_public_path__ + "static/media/season.1dc4c6e6.png";